export default "__VITE_ASSET__BwvIH8Id__"